import React from 'react';
import { ChevronDown } from 'lucide-react';

const GeoFaq = ({ faqs, title = 'Veelgestelde vragen' }) => {
  if (!faqs || faqs.length === 0) return null;
  return (
    <section className="py-16 bg-gray-50" aria-labelledby="geo-faq-heading" data-testid="geo-faq-section">
      <div className="max-w-4xl mx-auto px-4">
        <h2 id="geo-faq-heading" className="text-3xl font-bold text-[#202020] mb-8">{title}</h2>
        <div className="space-y-3">
          {faqs.map((f, i) => (
            <details key={i} className="group bg-white rounded-lg shadow-sm open:shadow-md" data-testid={`geo-faq-${i}`} open={i === 0}>
              <summary className="flex justify-between items-center cursor-pointer list-none px-6 py-4 font-semibold text-[#202020]">
                <h3 className="text-base md:text-lg font-semibold pr-4">{f.q}</h3>
                <ChevronDown className="h-5 w-5 text-[#3a190b] transition-transform group-open:rotate-180 flex-shrink-0" aria-hidden="true" />
              </summary>
              <p className="px-6 pb-5 text-[#202020]/75 leading-relaxed">{f.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GeoFaq;
